import React from 'react';
import { 
  BottomNavigation, 
  BottomNavigationAction,
  useMediaQuery,
  useTheme,
  Paper
} from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import PeopleIcon from '@mui/icons-material/People';
import PhotoLibraryIcon from '@mui/icons-material/PhotoLibrary';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PersonIcon from '@mui/icons-material/Person';
import FaceRetouchingNaturalIcon from '@mui/icons-material/FaceRetouchingNatural';

const Navigation = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const navigate = useNavigate();
  const location = useLocation();

  const isAuthPage = ['/splash', '/'].includes(location.pathname);
  if (isAuthPage) return null;

  const navItems = [
    { label: 'Events', icon: <DashboardIcon />, path: '/dashboard' },
    { label: 'Network', icon: <PeopleIcon />, path: '/network' },
    { label: 'Moments', icon: <PhotoLibraryIcon />, path: '/moments' },
    { label: 'Memory', icon: <FaceRetouchingNaturalIcon />, path: '/memory' },
    { label: 'Profile', icon: <PersonIcon />, path: '/profile' }
  ];

  if (isMobile) {
    return (
      <Paper 
        sx={{ 
          position: 'fixed', 
          bottom: 0, 
          left: 0, 
          right: 0,
          zIndex: theme.zIndex.appBar
        }} 
        elevation={3}
      >
        <BottomNavigation
          value={location.pathname}
          onChange={(event, newValue) => {
            navigate(newValue);
          }}
          showLabels
          sx={{
            '& .MuiBottomNavigationAction-root': {
              minWidth: 'auto',
              padding: '6px 8px',
              '& .MuiBottomNavigationAction-label': {
                fontSize: '0.7rem',
                lineHeight: 1.2,
                marginTop: '2px',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                maxWidth: '60px'
              },
              '& .MuiSvgIcon-root': {
                fontSize: '1.5rem'
              }
            }
          }}
        >
          {navItems.map((item) => (
            <BottomNavigationAction
              key={item.path}
              label={item.label}
              value={item.path}
              icon={item.icon}
            />
          ))}
        </BottomNavigation>
      </Paper>
    );
  }

  // Return null for desktop view since navigation is handled by the header
  return null;
};

export default Navigation; 
